/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React from 'react';
import { IconPlayLine, IconPauseLine } from '@instructure/ui-icons';
import { Button } from '@instructure/ui-buttons';
import { View } from '@instructure/ui-view';
import { translate } from '../../../constants/translated/translations';
import { RECORDING } from '../../../constants/CaptureStates';
const ContinueOrPauseButton = /*#__PURE__*/React.forwardRef(({
  captureState,
  actions
}, ref) => {
  ContinueOrPauseButton.displayName = 'ContinueOrPauseButton';
  const renderPause = () => {
    return /*#__PURE__*/React.createElement(Button, {
      id: "media_capture_pause_button" // needed for impact app
      ,
      ref: ref,
      withBackground: true,
      color: "primary-inverse",
      onClick: actions.pauseClicked,
      display: "block",
      renderIcon: IconPauseLine,
      themeOverride: {
        iconSizeMedium: '1.125rem'
      }
    }, translate('PAUSE'));
  };
  const renderContinue = () => {
    return /*#__PURE__*/React.createElement(Button, {
      id: "media_capture_continue_button" // needed for impact app
      ,
      ref: ref,
      withBackground: true,
      color: "primary-inverse",
      onClick: actions.continueClicked,
      display: "block",
      renderIcon: IconPlayLine,
      themeOverride: {
        iconSizeMedium: '1.125rem'
      }
    }, translate('CONTINUE'));
  };
  return /*#__PURE__*/React.createElement(View, null, captureState === RECORDING ? renderPause() : renderContinue());
});
export default ContinueOrPauseButton;